var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDecoIco5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.04846 3.92886L34.7677 31.6481L32.1527 34.2631L4.43344 6.54388L7.04846 3.92886Z",
    fill: "#474EFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7676 6.54386L7.04836 34.2631L4.43334 31.6481L32.1526 3.92884L34.7676 6.54386Z",
    fill: "#474EFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6219 1.59538L14.0089 37.9708L10.5773 36.5922L25.1903 0.216797L28.6219 1.59538Z",
    fill: "#474EFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3509 13.1044L2.2967 28.4928L0.844965 25.0915L36.8992 9.7031L38.3509 13.1044Z",
    fill: "#474EFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0982 28.1163L0.722778 13.5033L2.10136 10.0716L38.4768 24.6846L37.0982 28.1163Z",
    fill: "#474EFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5914 37.8508L10.203 1.7966L13.6044 0.344865L28.9927 36.3991L25.5914 37.8508Z",
    fill: "#474EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecoIco5);
export default __webpack_public_path__ + "static/media/decoIco5.0927860857fa76bbb2e166837eb8667f.svg";
export { ForwardRef as ReactComponent };